import { useEffect, useState } from "react";
import { IHealthCareContainerProps } from "./HealthCare.interfaces";
import HealthCareView from "./HealthCare.view";
import BroswerService from "../../Services/Browser.service";
export default function HealthCareContainer(props: IHealthCareContainerProps) {
   
       
    
    const [showDemo, setShowDemo] = useState(false);
    const demoController = () => setShowDemo(!showDemo);
    const [showlogin, setShowlogin] = useState(false);
    const loginController = () => setShowlogin(!showlogin);
    const scrollToHealthcareSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            // Add highlight effect
            element.classList.add('scroll-highlight');
            setTimeout(() => {
                element.classList.remove('scroll-highlight');
            }, 2000);
        }
    };

    useEffect(() => {
        BroswerService.setCustomTitle("HealthCareContainer");

        // Check if there's a pending scroll request from navigation
        const pendingScrollSection = sessionStorage.getItem('scrollToHealthcareSection');
        if (pendingScrollSection) {
            // Wait a bit for the component to fully render
            setTimeout(() => {
                scrollToHealthcareSection(pendingScrollSection);
                sessionStorage.removeItem('scrollToHealthcareSection');
            }, 800); // Increased timeout to ensure all content is loaded
        }
    }, []);
    
    return (
        <>
            <HealthCareView
                demoController={demoController}
                showDemo={showDemo}
                loginController={loginController}
                showlogin={showlogin}
                scrollToHealthcareSection={scrollToHealthcareSection}
            />
        </>
    );
}
